import React from 'react';
import { _defineHelpUrlandToolTip } from '../helpers/index.js'

const ControlsFlowStatements = function () {
    const name = "controls_flow_statements";
    ControlsFlowStatements.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#loops");

    return (
        <block type={name}></block>
    );
};

export default ControlsFlowStatements;